<template>
  <div>
    <v-row class="">
      <!--   :disabled=datosSA.length==0"   -->
      <!-- <v-col cols="auto pr-0">
                <v-btn class="btn_block_style2" dark  :disabled="parametros.evento == 'view'"
                    @click="$emit('nextTab')">SIGUIENTE</v-btn>
            </v-col> -->
    <!-- <v-col cols="auto pr-0">
              <v-btn class="btn_block_style2" dark  @click="LoadMain()">REFRESH</v-btn>
          </v-col> -->
    </v-row>

    <v-simple-table class="mt-8">
      <template v-slot:default>
        <thead>
          <tr class="secondary black--text">
            <th class="text-left">SECUENCIA DIDÁCTICA</th>
            <th class="text-left">PROCESOS PEDAGÓGICOS</th>
            <th class="text-left">ACTIVIDADES</th>
            <th class="text-left">RECURSOS</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="datosSA != null">
            <tr v-for="(secuencia, indexSecuencia) in datosSA.secuenciasDidacticas" :key="indexSecuencia">
              <td>
                <span>
                  {{ secuencia.secuencia.nombre }}
                </span>
              </td>
              <td>
                <div v-for="(proceso, indexProceso) in secuencia.procesosPedagogicos" :key="indexProceso">
                  {{ proceso.nombre }}
                </div>
              </td>
              <td>
                <v-tooltip bottom color="#1b1b1b">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" class="primary px-0 mx-0" fab x-small>
                      <v-icon>fa-eye</v-icon>
                    </v-btn>
                  </template>
                  <div class="py-0 my-0" v-for="(
                      proceso, indexProceso
                    ) in secuencia.procesosPedagogicos" :key="indexProceso">
                    <div v-for="(actividad, indexActividad) in proceso.actividades" :key="`Actividad${indexActividad}`">
                      {{ actividad.nombre }}<br />
                    </div>
                  </div>
                </v-tooltip>
              </td>
              <td>
                <div class="py-0 my-0" v-for="(proceso, indexProceso) in secuencia.procesosPedagogicos"
                  :key="indexProceso">
                  <div v-for="(recurso, indexRecurso) in proceso.recursos" :key="`Recurso${indexRecurso}`">
                    {{ recurso.nombre }}<br />
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>

    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModal"
      @reloadComp="ReloadComp">
    </component>

    <!--
        <SecuenciaDidacticaForm :estadoComp="estadoComponente" :parametros="parametroComp" 
                        @close="CloseModal"  @reloadComp="ReloadComp" >
        </SecuenciaDidacticaForm>
        -->
    <span v-if="test">
      Parametros {{ datosSA }} <br />
      Paramentros {{ parametros }}
    </span>

    <confirm @aceptar="DeleteSecuencia" @cancelar="CloseConfirm" :title="desc_confirm" :active="dialog_confirm" />
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import SecuenciaDidacticaForm from "./formSecuenciaDidactica.vue";
// import ComundataTablecompVue from '../../../../../components/ComponentsEst/ComundataTablecomp.vue';

export default {
  name: "secuenciaDidactica",

  components: {
    SecuenciaDidacticaForm,
  },

  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 141, id_modulo: 5 }, //sud_modulo y modulo
    datoLogin: sessionStorage, // variables de sesion del usuario
    test: false,

    ////////////////////////////////////////////////////////
    compName: "",
    estadoComponente: false,
    parametroComp: {},

    disabledForm: false,
    datosSA: {},
    // modal confirmacion
    indexProcesoDelete: -1,
    dialog_confirm: false,
    desc_confirm: "",
    //////////////////////////////////
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  created() {
    this.actualizarParamentro();
  },

  mounted() {
    this.LoadMain();
  },

  watch: {
    // cada vez que la pregunta cambie, esta función será ejecutada
    estadoComp(flag) {

      if (flag) {
        this.LoadMain();
      } else {
        // this.LimpiarForm();
      }
    },
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    ////////////////////////////////////////////////////////

    async LoadMain() {

      // this.LimpiarForm();
      // this.GetSecuencias()

       await this.GetSecuencias();

      if (this.parametros.evento == "ver") {
        this.disabledForm = true;
      }
    },

    async GetSecuencias() {
      try {

        let resp;

        if (this.parametros.evento == 'agregar') {

          if (this.parametros.tipo_contenido == 1) {
            resp = await axios.get(
              `/academico/sesionAprendizajeProg/secuenciaManager/${this.parametros.items.id_clase}`
            );
          } else {
            resp = await axios.get(
              `/academico/sesionAprendizaje/secuenciaDidactica/${this.parametros.items.id_sesion_aprendizaje}`
            );
          }

        } else if (this.parametros.evento == 'editar') {

          resp = await axios.get(
            `/academico/sesionAprendizajeProg/secuenciaDidactica/${this.parametros.items.id_sesion_aprendizaje}`
          );

        } else if (this.parametros.evento == 'ver') {

          resp = await axios.get(
            `/academico/sesionAprendizajeProg/secuenciaDidactica/${this.parametros.items.id_sesion_aprendizaje}`
          );
          
        } else if (this.parametros.evento == 'replicar') {

          resp = await axios.get(
            `/academico/sesionAprendizajeProg/secuenciaDidactica/${this.parametros.items.id_sesion_aprendizaje}`
          );

        }

        // this.parametros.evento == 'view'
        this.datosSA = resp.data;

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    CloseModal() {
      this.estadoComponente = false;
      // this.$emit('close')
    },

    ReloadComp() {
      this.LoadMain();
      this.estadoComponente = false;
    },

    async ShowModalDelete(secuencia) {
      this.id_delete = secuencia.id;
      this.desc_confirm = `¿Está seguro de eliminar este registro (${secuencia.secuencia.nombre} - ${secuencia.nombre})?`;
      this.dialog_confirm = true;
    },

    CloseConfirm() {
      this.indexProcesoDelete = -1;
      this.dialog_confirm = false;
    },

    async DeleteSecuencia() {
      try {
        var res = await axios.delete(
          `/academico/sesionAprendizajeProg/secuencia/${this.id_delete}/`
        );
        if (res.data.messageT == "S") {
          this.LoadMain();
        }
        this.setEnviarMens({
          tipo: res.data.messageT,
          mensaje: res.data.message,
          tiempo: 6000,
        });
      } catch (error) {
        this.setEnviarMens({
          tipo: res.data.messageT,
          mensaje: res.data.message,
          tiempo: null,
        });
      }
    },

    LimpiarForm() {
      this.disabledForm = true;
      this.datosSA = {};
    },
  },
};
</script>
